
import PlatformDetection from './platform-detection';

export default PlatformDetection;
